var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import ChatMessage from "./ChatMessage";
import { AppContext } from "../appContext";
import TimeAgo from "../Timeago";
var AgentChatMessage = function (props) {
    var _a;
    var getMessageTime = function () {
        return props.message.created_time * 1000;
    };
    var parentContext = useContext(AppContext);
    var agent = (_a = parentContext.agents) === null || _a === void 0 ? void 0 : _a.find(function (agent) {
        return agent.id === props.message.user_id;
    });
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsxs("div", __assign({ className: "chat__messages-agent-info" }, { children: [_jsxs("div", __assign({ className: "chat__messages-agent" }, { children: [_jsx("div", __assign({ className: "chat__messages-agent-avatar" }, { children: _jsx("img", { src: (agent === null || agent === void 0 ? void 0 : agent.profile_img_url)
                                        ? agent === null || agent === void 0 ? void 0 : agent.profile_img_url
                                        : parentContext.chatPrefs.widget.default_profile_image, alt: "Avatar" }) })), _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("li", __assign({ className: "chat__messages-list-item" }, { children: _jsx(ChatMessage, { message: props.message, sessionId: props.sessionId, updateMessage: function () { } }) })) }))] })), _jsx("div", __assign({ className: "chat__messages-timestamp" }, { children: _jsx(TimeAgo, { date: getMessageTime() }) }))] })) })) }));
};
export default AgentChatMessage;
